import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { WhyItDidntWork } from '../components/WhyItDidntWork';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { WhoIsNotForSection } from '../components/WhoIsNotForSection';
import { HowItWorks } from '../components/HowItWorks';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen" style={{
    backgroundColor: '#FAFAF7'
  }} data-id="element-251">
      <HeroSection data-id="element-252" />
      <OpeningHook data-id="element-253" />
      <ProblemSection data-id="element-254" />
      <WhyItDidntWork data-id="element-255" />
      <MechanismSection data-id="element-256" />
      <WhatYouGet data-id="element-257" />
      <WhoIsForSection data-id="element-258" />
      <WhoIsNotForSection data-id="element-259" />
      <HowItWorks data-id="element-260" />
      <ProofSection data-id="element-261" />
      <FAQSection data-id="element-262" />
      <OfferSection data-id="element-263" />
      <Footer data-id="element-264" />
    </main>;
}